import React, { useCallback, useEffect, useState } from 'react';
import { X } from 'lucide-react';
import './MovviConfigModal.css';

function authHeaders(token) {
  return {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json'
  };
}

export default function MovviConfigModal({ open, onClose, apiBaseUrl, onSaved }) {
  const [habilitado, setHabilitado] = useState(false);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState(null);
  const [msgOk, setMsgOk] = useState(null);

  const load = useCallback(async () => {
    const token = localStorage.getItem('authToken');
    if (!token) return;
    setLoading(true);
    setMsg(null);
    try {
      const res = await fetch(`${apiBaseUrl}/api/integracoes/movvi`, {
        headers: authHeaders(token)
      });
      const json = await res.json().catch(() => ({}));
      if (!res.ok || !json.success) {
        setMsg(json.message || 'Erro ao carregar.');
        setMsgOk(false);
        return;
      }
      const d = json.data || {};
      setHabilitado(!!(d.habilitado ?? d.configured));
    } catch (e) {
      setMsg(e.message || 'Erro de rede.');
      setMsgOk(false);
    } finally {
      setLoading(false);
    }
  }, [apiBaseUrl]);

  useEffect(() => {
    if (!open) return;
    load();
  }, [open, load]);

  const onToggle = async () => {
    const token = localStorage.getItem('authToken');
    if (!token || saving || loading) return;
    const next = !habilitado;
    setSaving(true);
    setMsg(null);
    try {
      const res = await fetch(`${apiBaseUrl}/api/integracoes/movvi`, {
        method: 'PUT',
        headers: authHeaders(token),
        body: JSON.stringify({ habilitado: next })
      });
      const json = await res.json().catch(() => ({}));
      if (!res.ok || !json.success) {
        setMsg(json.message || 'Erro ao salvar.');
        setMsgOk(false);
        return;
      }
      setHabilitado(next);
      setMsg(json.message || (next ? 'Integração habilitada.' : 'Integração desabilitada.'));
      setMsgOk(true);
      if (typeof onSaved === 'function') onSaved();
    } catch (e) {
      setMsg(e.message || 'Erro de rede.');
      setMsgOk(false);
    } finally {
      setSaving(false);
    }
  };

  if (!open) return null;

  const busy = loading || saving;

  return (
    <div className="movvi-modal-overlay">
      <div
        className="movvi-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="movvi-modal-title"
      >
        <div className="movvi-modal-header">
          <div>
            <h2 id="movvi-modal-title" className="movvi-modal-title">
              Movvi
            </h2>
            <p className="movvi-modal-sub">Habilite a integração Movvi para este cliente.</p>
          </div>
          <button type="button" className="movvi-modal-close" onClick={onClose} aria-label="Fechar">
            <X size={20} />
          </button>
        </div>
        <div className="movvi-modal-body">
          <div className="movvi-enable-row">
            <span className="movvi-enable-label">Habilitar integração</span>
            <button
              type="button"
              className={`movvi-toggle${habilitado ? ' movvi-toggle--on' : ''}`}
              role="switch"
              aria-checked={habilitado}
              aria-label="Habilitar integração Movvi"
              disabled={busy}
              onClick={onToggle}
            >
              <span className="movvi-toggle-knob" />
            </button>
          </div>
          {msg ? <div className={`movvi-msg ${msgOk ? 'success' : 'error'}`}>{msg}</div> : null}
        </div>
      </div>
    </div>
  );
}
